import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBXjPfa_dG7NnEFBHnM9TCAqImJdcTz5B8",
  authDomain: "sheba-1500445570528.firebaseapp.com",
  projectId: "sheba-1500445570528",
  storageBucket: "sheba-1500445570528.appspot.com",
  messagingSenderId: "1090538708148",
  appId: "1:1090538708148:web:71dd607e847c03b3b3cbe1",
  measurementId: "G-985FEJX47W",
};
// const firebaseConfig = {
//   apiKey: "AIzaSyDLMFcZxgAUobb9APTp_KBab20hkpDJk44",
//   authDomain: "bondhu-test.firebaseapp.com",
//   projectId: "bondhu-test",
//   storageBucket: "bondhu-test.firebasestorage.app",
//   messagingSenderId: "782539572600",
//   appId: "1:782539572600:web:398d2f6e177956f765f48d",
//   measurementId: "G-0MR7820YJN",
// };

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
// };

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BMwwMktFnv4MKrwreKwwn52EfYOHjolMpKuJcFYiYtqCJovxUKRsVbT11FXRgYWBZ3l3Grwj_eTdxVvk8V7iDcE",
      // vapidKey:
      //   "BHBrmA856S1_c6oSv_V9nzPpwiqFNL9MS1W4eKuCeJt3nfWKNMKvB8xQ0NecPqZmtDw0AK_lriO-LFwmhCfzbnE",
    });

    return token;
  }
};
